<template>
  <div v-if="isLoaded">
    <!-- wraper -->
    <div class="wraper">
      <!-- HEADER -->
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <div class="row myrow">
          <div class="col-xs-12 mycol header-title header-title-transpatrent">
            <div class="page-title">
              <a @click="moveBack" class="header-link-back" />
              {{ questions.TITLE }}
            </div>
          </div>
        </div>
      </div>
      <!-- HEADER -->
      <div class="container-fluid mycontainer-fluid page-content">
        <div v-if="!isQuestionsLoading" class="row">
          <div class="col-xs-12">
            <div class="container-flex container-flex-card row myrow">
              <div class="container-col col-xs-12 col-md-12 col-lg-4 mycol">
                <div
                  v-if="isEditMode"
                  class="container-stl container-stl-card expert-container-stl-card"
                >
                  <div class="container-stl-title">Общая информация</div>
                  <div class="container-stl-body">
                    <div class="expert-form-stl expert-edit-form-info">
                      <div class="form-group">
                        <label for="UF_SORT" class="expert-edit-form__label"
                          >№ п/п</label
                        >
                        <select
                          d="UF_SORT"
                          class="form-control"
                          v-model="questions.item.UF_SORT"
                        >
                          <option :value="item"></option>
                          <option
                            v-for="item in 100"
                            v-bind:key="item"
                            v-bind:value="item"
                            v-text="item"
                            :disabled="checkIsVisibleDisable(item)"
                            class="form-control"
                          ></option>
                        </select>
                      </div>
                      <div
                        v-if="
                          questions.item.TYPE_QUESTION.CODE !== 'free_question'
                        "
                        class="form-group"
                      >
                        <label
                          for="PROJECT_UF_NUMBER"
                          class="expert-edit-form__label"
                          >№ проекта</label
                        >
                        <div id="PROJECT_UF_NUMBER">
                          <router-link
                            v-if="questions.item.UF_PROJECT_ID"
                            :to="{
                              name: 'ProjectEdit',
                              params: { id: questions.item.UF_PROJECT_ID }
                            }"
                            style="text-decoration-line: underline;"
                            >{{ questions.item.PROJECT_UF_NUMBER }}
                          </router-link>
                          <template v-else>
                            {{ questions.item.PROJECT_UF_NUMBER }}
                          </template>
                        </div>
                      </div>
                      <div
                        v-if="
                          questions.item.TYPE_QUESTION.CODE !== 'free_question'
                        "
                        class="form-group"
                      >
                        <label
                          for="COMPANY_NAME"
                          class="expert-edit-form__label"
                          >Организация</label
                        >
                        <div id="COMPANY_NAME">
                          {{ questions.item.COMPANY.FULLNAME }}
                        </div>
                      </div>
                      <div
                        v-if="
                          questions.item.TYPE_QUESTION.CODE !== 'free_question'
                        "
                        class="form-group"
                      >
                        <label
                          for="PROGRAM_NAME"
                          class="expert-edit-form__label"
                          >Программа</label
                        >
                        <div id="PROGRAM_NAME">
                          {{ questions.item.PROGRAM.NAME }}
                        </div>
                      </div>
                      <div
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project_'"
                        class="form-group"
                      >
                        <label
                          for="UF_PROJECT_NAME"
                          class="expert-edit-form__label"
                          >Проект</label
                        >
                        <div id="UF_PROJECT_NAME">
                          {{ questions.item.PROJECT_UF_NAME }}
                        </div>
                      </div>
                      <div
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project'"
                        class="form-group"
                      >
                        <label class="expert-edit-form__label"
                          >Тип вынесения</label
                        >
                        <select
                          v-model="questions.item.UF_TYPE_MAKING"
                          class="form-control"
                        >
                          <option
                            v-for="item in questions.SP_TYPE_MAKING"
                            :value="item.ID"
                            :key="item.ID"
                            v-text="item.NAME"
                          />
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="UF_NAME" class="expert-edit-form__label"
                          >Вопрос</label
                        >
                        <textarea
                          v-if="questions.item.TYPE_QUESTION.CODE !== 'project'"
                          name="UF_NAME"
                          class="form-control stl-textarea-rn"
                          v-model="questions.item.UF_NAME"
                        />
                        <div v-else>
                          {{ questions.item.UF_NAME }}
                        </div>
                      </div>
                      <div
                        v-if="questions.item.TYPE_QUESTION.CODE === 'technikal'"
                        class="form-group"
                      >
                        <label
                          for="UF_STATUS_DOGOVOR"
                          class="expert-edit-form__label"
                          >Статус договора</label
                        >
                        <div id="UF_STATUS_DOGOVOR">
                          {{ questions.item.STATUS.DOGOVOR }}
                        </div>
                      </div>
                      <div
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project'"
                        class="form-group"
                      >
                        <label
                          for="TYPE_QUESTION_NAME"
                          class="expert-edit-form__label"
                          >Тип вопроса</label
                        >
                        <div id="TYPE_QUESTION_NAME">
                          {{ questions.item.TYPE_QUESTION.NAME }}
                        </div>
                      </div>
                      <div
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project'"
                        class="form-group"
                      >
                        <label for="STATUS_NAME" class="expert-edit-form__label"
                          >Статус заявки</label
                        >
                        <div id="STATUS_NAME">
                          {{ questions.item.STATUS.NAME }}
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-if="questions.item.TYPE_QUESTION.CODE !== 'project'"
                      >
                        <label
                          for="MANAGER_NAME"
                          class="expert-edit-form__label"
                          >Докладчик</label
                        >
                        <Multiselect
                          label="FIO_FULL"
                          class="form-control i-main-style stl-bs_bb multiselect-form-full select-new-filter-style"
                          :limit="1"
                          :limitText="filterItemText"
                          track-by="ID"
                          v-model="questions.item.SPEAKER"
                          :options="questions.ALL_FOND_USER_LIST"
                          :multiple="false"
                          placeholder="Укажите докладчика"
                          style="background-image: none;"
                        >
                          <span slot="noOptions">Пользователи не найдены</span>
                          <span slot="noResult">Пользователи не найдены</span>
                        </Multiselect>
                      </div>
                      <div
                        v-else-if="
                          questions.item.TYPE_QUESTION.CODE == 'project'
                        "
                        class="form-group"
                      >
                        <label
                          for="MANAGER_NAME"
                          class="expert-edit-form__label"
                          >Докладчик</label
                        >
                        <div id="STATUS_NAME">
                          {{ questions.item.MANAGER.NAME }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="UF_COMMENT" class="expert-edit-form__label"
                          >Комментарий</label
                        >
                        <textarea
                          id="UF_COMMENT"
                          class="form-control  stl-textarea-rn"
                          placeholder="Напишите комментарий"
                          v-model="questions.item.UF_COMMENT"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="footer-stl-card-contol container-stl-body">
                    <a
                      @click="saveQuestion"
                      class="butt-blue butt-stl stl-mr-10 butt-w-100"
                    >
                      Сохранить
                    </a>
                    <a
                      @click="resetChanges"
                      class="butt-black butt-stl butt-w-100"
                    >
                      Отмена
                    </a>
                  </div>
                </div>
                <div
                  v-else
                  class="container-stl container-stl-card expert-container-stl-card"
                >
                  <div class="container-stl-title">Общая информация</div>
                  <table class="container-stl-table expert-table-info">
                    <tbody>
                      <tr>
                        <td class="td-name">№ п/п</td>
                        <td class="text-left">{{ questions.item.UF_SORT }}</td>
                      </tr>
                      <tr
                        v-if="
                          questions.item.TYPE_QUESTION.CODE !== 'free_question'
                        "
                      >
                        <td class="td-name">№ проекта</td>
                        <td class="text-left">
                          <router-link
                            v-if="questions.item.UF_PROJECT_ID"
                            :to="{
                              name: 'ProjectEdit',
                              params: { id: questions.item.UF_PROJECT_ID }
                            }"
                            style="text-decoration-line: underline;"
                            >{{ questions.item.PROJECT_UF_NUMBER }}
                          </router-link>
                          <template v-else>
                            {{ questions.item.PROJECT_UF_NUMBER }}
                          </template>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          questions.item.TYPE_QUESTION.CODE !== 'free_question'
                        "
                      >
                        <td class="td-name">Организация</td>
                        <td class="text-left">
                          {{ questions.item.COMPANY.FULLNAME }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          questions.item.TYPE_QUESTION.CODE !== 'free_question'
                        "
                      >
                        <td class="td-name">Программа</td>
                        <td class="text-left">
                          {{ questions.item.PROGRAM.NAME }}
                        </td>
                      </tr>
                      <tr
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project_'"
                      >
                        <td class="td-name">Проект</td>
                        <td class="text-left">
                          {{ questions.item.PROJECT_UF_NAME }}
                        </td>
                      </tr>
                      <tr
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project'"
                      >
                        <td class="td-name">Тип вынесения</td>
                        <td class="text-left">
                          {{ questions.item.TYPE_MAKING.NAME }}
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name">Вопрос</td>
                        <td class="text-left">
                          {{ questions.item.UF_NAME }}
                        </td>
                      </tr>
                      <tr
                        v-if="questions.item.TYPE_QUESTION.CODE === 'technikal'"
                      >
                        <td class="td-name">Статус договора</td>
                        <td class="text-left">
                          {{ questions.item.STATUS.DOGOVOR }}
                        </td>
                      </tr>
                      <tr
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project'"
                      >
                        <td class="td-name">Тип вопроса</td>
                        <td class="text-left">
                          {{ questions.item.TYPE_QUESTION.NAME }}
                        </td>
                      </tr>
                      <tr
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project'"
                      >
                        <td class="td-name">Статус заявки</td>
                        <td class="text-left">
                          {{ questions.item.STATUS.NAME }}
                        </td>
                      </tr>
                      <tr
                        v-if="questions.item.TYPE_QUESTION.CODE !== 'project'"
                      >
                        <td class="td-name">Докладчик</td>
                        <td class="text-left">
                          {{ questions.item.SPEAKER.FIO_FULL }}
                        </td>
                      </tr>
                      <tr
                        v-else-if="
                          questions.item.TYPE_QUESTION.CODE == 'project'
                        "
                      >
                        <td class="td-name">Докладчик</td>
                        <td class="text-left">
                          {{ questions.item.MANAGER.NAME }}
                        </td>
                      </tr>

                      <tr
                        v-if="questions.item.TYPE_QUESTION.CODE === 'project'"
                      >
                        <td class="td-name">Сумма займа, тыс. руб.</td>
                        <td class="text-left">
                          {{ questions.item.UF_SUM_REQUEST }}
                        </td>
                      </tr>
                      <tr>
                        <td class="td-name">Комментарий</td>
                        <td class="text-left">
                          {{ questions.item.UF_COMMENT }}
                        </td>
                      </tr>

                      <template
                        v-if="
                          questions.item.TYPE_QUESTION.CODE !== 'free_question'
                        "
                      >
                        <tr>
                          <td class="td-name">Договоры организации</td>
                          <td class="text-left">
                            <template
                              v-if="
                                questions.dogovorDZInfo.DOGOVOR_ORG.length > 0
                              "
                            >
                              <span
                                v-for="(projectDz, ind) in questions
                                  .dogovorDZInfo.DOGOVOR_ORG"
                              >
                                <router-link
                                  v-if="projectDz.ID"
                                  :to="{
                                    name: 'ProjectEdit',
                                    params: { id: projectDz.ID }
                                  }"
                                  style="text-decoration-line: underline;"
                                  :style="
                                    projectDz.IS_COLOR_GRAY == 1
                                      ? 'color:#696969'
                                      : 'color:#000000'
                                  "
                                  >{{ projectDz.UF_NUMBER }} ({{
                                    projectDz.UF_TEXT_DOGOVOR
                                  }})</router-link
                                >
                                {{
                                  ind ==
                                  questions.dogovorDZInfo.DOGOVOR_ORG.length - 1
                                    ? ""
                                    : ",&nbsp;"
                                }}
                              </span>
                            </template>
                            <template v-else>
                              Нет
                            </template>
                          </td>
                        </tr>

                        <tr>
                          <td class="td-name">Состоит в группе компаний</td>
                          <td class="text-left">
                            {{ questions.dogovorDZInfo.GROUP_ORG_NAME }}
                          </td>
                        </tr>

                        <tr
                          v-if="
                            questions.dogovorDZInfo.GROUP_ORG_NAME !== 'Нет' &&
                              typeof questions.dogovorDZInfo
                                .GROUP_ORG_PROJECT_INFO === 'object' &&
                              !Array.isArray(
                                questions.dogovorDZInfo.GROUP_ORG_PROJECT_INFO
                              ) &&
                              questions.dogovorDZInfo.GROUP_ORG_PROJECT_INFO !==
                                null
                          "
                        >
                          <td class="td-name">Проекты группы компаний</td>
                          <td class="text-left">
                            <p
                              v-for="org in questions.dogovorDZInfo
                                .GROUP_ORG_PROJECT_INFO"
                            >
                              {{ org.ORG_INFO.UF_NAME }} -
                              <span v-for="(project, ind) in org.PROJECT_LIST">
                                <router-link
                                  v-if="project.ID"
                                  :to="{
                                    name: 'ProjectEdit',
                                    params: { id: project.ID }
                                  }"
                                  style="text-decoration-line: underline;"
                                  :style="
                                    project.IS_COLOR_GRAY == 1
                                      ? 'color:#696969'
                                      : 'color:#000000'
                                  "
                                  >{{ project.UF_NUMBER }} ({{
                                    project.UF_TEXT_DOGOVOR
                                  }})</router-link
                                >
                                {{
                                  ind == org.PROJECT_LIST.length - 1
                                    ? ""
                                    : ",&nbsp;"
                                }}
                              </span>
                            </p>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="footer-stl-card-contol container-stl-body">
                    <a
                      v-if="questions.item.IS_EDIT_ROW === 1"
                      @click="setEditMode(true)"
                      class="butt-blue butt-stl stl-mr-10"
                    >
                      редактировать
                    </a>
                    <a
                      v-if="questions.item.IS_DELETE_ROW === 1"
                      @click="setModalDelAdvice(true)"
                      class="butt-red butt-stl butt-w-100"
                    >
                      удалить
                    </a>
                  </div>
                </div>

                <div
                  class="container-stl container-stl-card expert-container-stl-card"
                >
                  <div class="container-stl-title df-ac df-js-b">
                    Задачи
                    <template
                      v-if="questions.item.UF_IS_DELETE_AFTER_VIEW_SOVET != 1"
                    >
                      <a
                        @click="setModalAddTaskDoc(true)"
                        class="butt-blue-add butt-stl stl-mr-10 but-w-100"
                      >
                        <span class="butt-plus">+</span>Добавить
                      </a>
                    </template>
                  </div>
                  <div class="container-stl-body table-responsive">
                    <table
                      class="container-stl-table expert-table-stl expert-table-stl2"
                    >
                      <thead>
                        <th v-if="questions.typeSovet !== 'rgm'">Вид</th>
                        <th>Задача</th>
                        <th v-if="questions.typeSovet === 'rgm'">Проект</th>
                        <th>Постановщик</th>
                        <th>Ответственный</th>
                        <th v-if="questions.typeSovet === 'rgm'">Срок</th>
                        <th>Статус</th>
                      </thead>
                      <tbody v-if="questions.ListTaskB24.length">
                        <tr
                          v-for="(item, index) in questions.ListTaskB24"
                          :key="index"
                        >
                          <td v-if="questions.typeSovet !== 'rgm'">
                            {{ item.VID_NAME }}
                          </td>
                          <td>
                            <a :href="item.TASK_LINK" target="_blank">
                              {{ item.TASK_NAME }}
                            </a>
                          </td>
                          <td v-if="questions.typeSovet === 'rgm'">
                            <template v-if="item.PROJECT_LINK_LIST">
                              <a
                                v-for="project in item.PROJECT_LINK_LIST"
                                :href="project.LINK"
                                target="_blank"
                              >
                                №{{ project.LABEL }} </a
                              ><br />
                            </template>
                          </td>
                          <td>{{ item.CREATOR_USER }}</td>
                          <td>{{ item.EXECUTOR_USER }}</td>
                          <td v-if="questions.typeSovet === 'rgm'">
                            {{ item.DEADLINE }}
                          </td>
                          <td>{{ item.STATUS_NAME }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!--      docs        -->
              <div class="container-col col-xs-12 col-md-12 col-lg-8 mycol">
                <div class="container-stl container-stl-card">
                  <div class="container-stl-title">Документы</div>
                  <table class="container-stl-table expert-table-stl">
                    <thead>
                      <th style="width: 87px;">№</th>
                      <th>Документ</th>
                      <th class="text-center stl-w-190">Дата загрузки</th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </thead>
                    <template v-if="questions.isGroupDocuments">
                      <tbody
                        v-for="(itemGr, indexGr) in questions.groupList"
                        :key="indexGr"
                      >
                        <!-- группа -->
                        <tr>
                          <td
                            colspan="4"
                            :style="
                              itemGr.IS_CLOSE ? 'padding-left: 10px;' : ''
                            "
                          >
                            <a
                              href="javascript:void(0)"
                              v-if="itemGr.IS_CLOSE"
                              @click="closeRazdel()"
                              class="table-question-link"
                              :class="
                                !isCloseDocumentRazdel ? 'close-area' : ''
                              "
                            >
                              <i class="open-conteiner-icon" />
                              <b>{{ itemGr.NAME }}</b>
                            </a>
                            <b v-else>{{ itemGr.NAME }}</b>
                          </td>
                        </tr>
                        <!-- документы  -->
                        <template
                          v-for="(itemL1, indexL1) in questions.item
                            .DOCUMENTS_LIST_GROUP"
                        >
                          <tr
                            v-for="(item, index) in itemL1"
                            :key="index"
                            v-if="
                              indexL1 == itemGr.ID &&
                                (!itemGr.IS_CLOSE ||
                                  (itemGr.IS_CLOSE && !isCloseDocumentRazdel))
                            "
                          >
                            <td class="td-name">{{ item.UF_GROUP_SORT }}</td>
                            <td>
                              <a
                                v-if="
                                  item.FILE_FULL_INFO &&
                                    item.FILE_FULL_INFO !== ''
                                "
                                :href="item.FILE_FULL_INFO"
                                target="_blank"
                                class="stl-link-black"
                              >
                                {{ item.UF_NAME }}
                              </a>
                              <a
                                v-else-if="item.UF_IS_AUTO_GENERATE == 1"
                                @click="openGeneretaDoc(item.ID)"
                                class="stl-link-black"
                              >
                                {{ item.UF_NAME }}
                              </a>
                              <a
                                v-else-if="item.UF_FILE_ID > 0"
                                @click="openDoc(item.UF_FILE_ID)"
                                class="stl-link-black"
                              >
                                {{ item.UF_NAME }}
                              </a>
                              <div v-else>
                                {{ item.UF_NAME }}
                              </div>
                            </td>
                            <td class="text-center">
                              {{ item.UF_DATE_LOAD }}
                            </td>
                            <td style="width: 30px; padding: 8px 0 8px 0;">
                              <a
                                v-if="item.IS_VIEW_HISTORY_DOC_LIST"
                                title="История загрузки документов"
                                class="icon-item status-history"
                                @click="openHistoryModal(item)"
                              ></a>
                            </td>
                            <td style="width: 30px; padding: 8px 0 8px 0;">
                              <a
                                v-if="item.IS_EDIT === 1"
                                @click="setModalEditDoc(true, item)"
                                class="icon-item icon-edit-link"
                              />
                            </td>
                            <td style="width: 30px; padding-left: 4px;">
                              <a
                                v-if="item.IS_DELETE === 1"
                                @click="setModalDelDoc(true, item)"
                                class="icon-item icon-delete-link"
                              />
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </template>
                    <template v-else>
                      <tbody>
                        <tr
                          v-for="(item, index) in questions.item.DOCUMENTS_LIST"
                          :key="index"
                        >
                          <td class="td-name">{{ item.UF_SORT }}</td>
                          <td>
                            <a
                              v-if="
                                item.FILE_FULL_INFO &&
                                  item.FILE_FULL_INFO !== ''
                              "
                              :href="item.FILE_FULL_INFO"
                              target="_blank"
                              class="stl-link-black"
                            >
                              {{ item.UF_NAME }}
                            </a>
                            <a
                              v-else-if="item.UF_IS_AUTO_GENERATE == 1"
                              @click="openGeneretaDoc(item.ID)"
                              class="stl-link-black"
                            >
                              {{ item.UF_NAME }}
                            </a>
                            <a
                              v-else-if="item.UF_FILE_ID > 0"
                              @click="openDoc(item.UF_FILE_ID)"
                              class="stl-link-black"
                            >
                              {{ item.UF_NAME }}
                            </a>
                            <div v-else>
                              {{ item.UF_NAME }}
                            </div>
                          </td>
                          <td class="text-center">
                            {{ item.UF_DATE_LOAD }}
                          </td>
                          <td style="width: 30px; padding: 8px 0 8px 0;">
                            <a
                              v-if="item.IS_VIEW_HISTORY_DOC_LIST"
                              title="История загрузки документов"
                              class="icon-item status-history"
                              @click="openHistoryModal(item)"
                            ></a>
                          </td>
                          <td style="width: 30px; padding: 8px 0 8px 0;">
                            <a
                              v-if="item.IS_EDIT === 1"
                              @click="setModalEditDoc(true, item)"
                              class="icon-item icon-edit-link"
                            />
                          </td>
                          <td style="width: 30px; padding-left: 4px;">
                            <a
                              v-if="item.IS_DELETE === 1"
                              @click="setModalDelDoc(true, item)"
                              class="icon-item icon-delete-link"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </table>
                  <div class="footer-stl-table-contol container-stl-body">
                    <a
                      v-if="questions.item.IS_ADD_FILE === 1"
                      @click="setModalAddDoc(true)"
                      class="butt-blue-add butt-stl stl-mr-10 but-w-100"
                    >
                      <span class="butt-plus">+</span>Добавить документ
                    </a>

                    <div
                      v-if="
                        questions.item.DOCUMENTS_LIST.length > 0 ||
                          questions.item.DOCUMENTS_COUNT > 0
                      "
                      @click="getArchive(questions.item.ID)"
                      class="doc-arcive-box"
                      style="cursor: pointer; width:80px;"
                    >
                      <button
                        type="button"
                        class="butt-stl butt-blue"
                        style="height:32px; font-size: 12px;"
                      >
                        Скачать все
                      </button>
                      <!--Архив &nbsp;
                    <div class="icon-item-archive" />-->
                    </div>
                  </div>
                </div>
              </div>
              <!-- container-col -->
            </div>
          </div>
        </div>

        <!-- Редактирование документа к вопросу -->
        <div
          v-if="isEditDocModalView"
          class="modal fade in"
          :class="{ show: isEditDocModalView }"
          tabindex="-1"
          role="dialog"
        >
          <form>
            <div class="modal-dialog modal-new-style" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    @click="setModalEditDoc(false)"
                    type="button"
                    class="close"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">
                    Редактирование документа к вопросу
                  </h4>
                </div>
                <div class="modal-body" style="margin-bottom: 20px;">
                  <div class="form-group">
                    <label>№ п/п</label>
                    <input
                      class="form-control"
                      placeholder=""
                      v-model="editDocForm.UF_SORT"
                      :disabled="true"
                    />
                  </div>
                  <div class="form-group">
                    <label>Тип документа</label>
                    <select
                      v-model="editDocForm.UF_TYPE_DOCUMENTS"
                      class="form-control"
                      :disabled="true"
                    >
                      <option
                        v-for="item in questions.SP_TYPE_DOCUMENTS"
                        :value="item.ID"
                        :key="item.ID"
                        v-text="item.NAME"
                      />
                    </select>
                  </div>
                  <div class="form-group" v-if="isNeedNamingEdit">
                    <label>Название документа</label>
                    <input
                      class="form-control"
                      placeholder="Введите наименование"
                      v-model="editDocForm.UF_NAME"
                    />
                  </div>
                  <div class="form-group form-group-add-file">
                    <div class="conteiner-add-file">
                      <label class="conteiner-add-file-title">Файл:</label>
                      <label class="conteiner-add-file">
                        <input
                          type="file"
                          :accept="accept"
                          name="file"
                          ref="file"
                          @change="editFile"
                        />
                        <span
                          class="conteiner-add-file-butt butt-blue butt-stl"
                        >
                          Выберите файл
                        </span>
                        <span
                          v-if="!fileName.length"
                          class="conteiner-add-file-text"
                        >
                          Файл не выбран
                        </span>
                        <span v-else class="conteiner-add-file-text">{{
                          fileName
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    @click="setModalEditDoc(false)"
                    type="button"
                    class="butt-stl butt-black"
                    data-dismiss="modal"
                  >
                    отменить
                  </button>
                  <button
                    @click="editDoc"
                    type="button"
                    class="butt-stl butt-blue"
                  >
                    Сохранить
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- /.modal -->
        <!-- Редактирование документа к вопросу -->

        <!-- Добавление документа к вопросу -->
        <div
          v-if="isAddDocModalView"
          class="modal fade in"
          :class="{ show: isAddDocModalView }"
          tabindex="-1"
          role="dialog"
        >
          <form>
            <div class="modal-dialog modal-new-style" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    @click="setModalAddDoc(false)"
                    type="button"
                    class="close"
                    aria-label="Close"
                  >
                    <span>&times;</span>
                  </button>
                  <h4 class="modal-title">Добавление документа к вопросу</h4>
                </div>
                <div class="modal-body" style="margin-bottom: 20px;">
                  <div class="form-group">
                    <label>№ п/п</label>
                    <input
                      class="form-control"
                      placeholder="Введите номер"
                      v-model="addDocForm.UF_SORT"
                      :disabled="true"
                    />
                  </div>
                  <div class="form-group">
                    <label>Тип документа</label>
                    <select
                      v-model="addDocForm.UF_TYPE_DOCUMENTS"
                      class="form-control"
                    >
                      <option
                        v-for="item in questions.SP_TYPE_DOCUMENTS"
                        :value="item.ID"
                        :key="item.ID"
                        v-text="item.NAME"
                      />
                    </select>
                  </div>
                  <div class="form-group" v-if="isNeedNaming">
                    <label>Название документа</label>
                    <input
                      class="form-control"
                      placeholder="Введите наименование"
                      v-model="addDocForm.UF_NAME"
                    />
                  </div>
                  <div class="form-group form-group-add-file">
                    <div class="conteiner-add-file">
                      <label class="conteiner-add-file-title">Файл:</label>
                      <label class="conteiner-add-file">
                        <input
                          type="file"
                          :accept="accept"
                          name="file"
                          ref="file"
                          @change="changeFile"
                        />
                        <span class="conteiner-add-file-butt butt-blue butt-stl"
                          >Выберите файл</span
                        >
                        <span
                          v-if="!fileName.length"
                          class="conteiner-add-file-text"
                          >Файл не выбран</span
                        >
                        <span v-else class="conteiner-add-file-text">{{
                          fileName
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    @click="setModalAddDoc(false)"
                    type="button"
                    class="butt-stl butt-black"
                    data-dismiss="modal"
                  >
                    отменить
                  </button>
                  <button
                    @click="addDoc"
                    type="button"
                    class="butt-stl butt-blue"
                  >
                    Сохранить
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- /.modal -->
        <!-- Добавление документа к вопросу -->

        <!-- Удалить вопрос -->
        <div
          v-if="isDelModalView"
          class="modal fade in"
          :class="{ show: isDelModalView }"
          tabindex="-1"
          role="dialog"
        >
          <form>
            <div
              class="modal-dialog modal-new-style modal-dialog-centered"
              role="document"
            >
              <div
                class="modal-content"
                :style="
                  isDeleteProjectQuestion(questions.item)
                    ? 'min-width: 600px;'
                    : ''
                "
              >
                <div class="modal-header" style="text-align: center">
                  <button
                    @click="setModalDelAdvice(false)"
                    type="button"
                    class="close"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Удалить вопрос?</h4>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <p v-if="isDeleteProjectQuestion(questions.item)">
                      Для удаления вопроса №{{ questions.item.UF_SORT }} из
                      заседаний нужно выбрать новую дату заседания или
                      прекратить работу по проекту. Как поступим?
                    </p>
                    <p v-else>
                      Вы действительно хотите удалить вопрос №
                      {{ questions.item.UF_SORT }}? Данное действие невозможно
                      будет восстановить.
                    </p>
                  </div>
                </div>
                <div
                  class="modal-footer df-js-b"
                  v-if="isDeleteProjectQuestion(questions.item)"
                >
                  <button
                    type="button"
                    class="butt-stl butt-stl-small2 butt-green"
                    style="padding: 8px;"
                    data-dismiss="modal"
                    @click="setDataTransferProject(questions.item)"
                  >
                    Выбрать новое заседание
                  </button>

                  <button
                    type="button"
                    class="butt-stl butt-stl-small2 butt-yellow"
                    style="padding: 8px;"
                    data-dismiss="modal"
                    @click="
                      isDelModalView = false;
                      showDialogEndWorkProject = true;
                    "
                  >
                    Прекратить работу по проекту
                  </button>

                  <button
                    type="button"
                    class="butt-stl butt-stl-small2 butt-red"
                    style="padding: 8px;"
                    @click="setModalDelAdvice(false)"
                  >
                    Закрыть
                  </button>
                </div>
                <div class="modal-footer  df-js-b" v-else>
                  <button
                    @click="removeAdvice"
                    type="button"
                    class="butt-stl butt-green"
                  >
                    Да
                  </button>
                  <button
                    @click="setModalDelAdvice(false)"
                    type="button"
                    class="butt-stl butt-red"
                    data-dismiss="modal"
                  >
                    Нет
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- /.modal -->
        <!-- Удалить вопрос -->

        <!-- дополнительный вопрос - полная блокировка ЭС -->
        <div
          class="modal fade in"
          v-bind:class="{ show: showDialogEndWorkProject }"
          tabindex="-1"
          role="dialog"
        >
          <form>
            <div
              class="modal-dialog modal-dialog-md modal-new-style modal-dialog-centered"
              role="document"
            >
              <div class="modal-content" style="min-width: 580px;">
                <div class="modal-header">
                  <button type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title" style="text-align: center;">
                    Удалить вопрос?
                  </h4>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <p>
                      Вы точно уверены в том, что хотите исключить проект из
                      повестки и прекратить работу по нему? В случае
                      положительного ответа - статус проекта изменится на
                      "Работа по проекту прекращена", вернуть назад его уже не
                      получится.
                    </p>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="butt-stl butt-stl-small2  butt-yellow"
                    v-on:click="setEndWorkProject()"
                  >
                    Прекратить работу по проекту
                  </button>
                  <button
                    type="button"
                    class="butt-stl butt-stl-small2 butt-red"
                    data-dismiss="modal"
                    v-on:click="showDialogEndWorkProject = false"
                  >
                    Закрыть
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- дополнительный вопрос - полная блокировка ЭС -->

        <!-- Удалить документ -->
        <div
          v-if="isDelDocModalView"
          class="modal fade in"
          :class="{ show: isDelDocModalView }"
          tabindex="-1"
          role="dialog"
        >
          <form>
            <div
              class="modal-dialog modal-new-style modal-dialog-centered"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    @click="setModalDelDoc(false)"
                    type="button"
                    class="close"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Удалить документ?</h4>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <p>
                      Вы действительно хотите удалить документ "{{
                        doc.UF_NAME
                      }}"? Данное действие невозможно будет восстановить.
                    </p>
                  </div>
                </div>
                <div class="modal-footer df-js-b">
                  <button
                    @click="removeDoc"
                    type="button"
                    class="butt-stl butt-green"
                  >
                    Да
                  </button>
                  <button
                    @click="setModalDelDoc(false)"
                    type="button"
                    class="butt-stl butt-red"
                    data-dismiss="modal"
                  >
                    Нет
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- /.modal -->
        <!-- Удалить документ -->

        <!-- Удалить вопрос -->
        <!-- Диалог смены ЭС для проекта -->
        <div
          class="modal fade in"
          id=""
          tabindex="-1"
          role="dialog"
          v-bind:class="{ show: showChangeSovet }"
        >
          <form v-on:submit.prevent="onSendTransferProject">
            <div
              class="modal-dialog modal-dialog-md modal-new-style modal-dialog-centered"
              role="document"
            >
              <div class="modal-content" style="min-width: 600px;">
                <div class="modal-header">
                  <button type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Выберите заседание</h4>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label>
                      Номер заседания
                    </label>
                    <select
                      class="form-control"
                      @change="changeTransferProject"
                      v-model="transferProject.id_sovet"
                    >
                      <option
                        v-for="item in questions.LIST_SOVET_ACTUAL"
                        v-bind:key="item.ID"
                        v-bind:value="item.ID"
                        v-text="item.LABEL"
                        v-if="item.UF_TYPE_SOVET.CODE === questions.typeSovet"
                        class="form-control"
                      ></option>
                    </select>

                    <template v-if="isViewTransferFormProject">
                      <div class="form-group">
                        <h4
                          class="modal-title"
                          style="font-size: 16px; font-weight: 600;"
                        >
                          Добавление вопроса
                        </h4>
                      </div>
                      <div class="form-group">
                        <label>Тип вопроса</label>
                        <select
                          class="form-control"
                          disabled
                          v-model="transferProject.type_question"
                        >
                          <option value="" disabled>Укажите тип вопроса</option>
                          <option
                            v-for="item in directory.sp_question_expert_sovet_type"
                            v-bind:key="item.ID"
                            v-bind:value="item.ID"
                            v-text="item.NAME"
                          ></option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Проект</label>
                        <select
                          class="form-control"
                          disabled
                          v-model="transferProject.projectId"
                        >
                          <option value="" disabled>Укажите тип вопроса</option>
                          <option
                            v-bind:key="transferProject.projectId"
                            v-bind:value="transferProject.projectId"
                            v-text="transferProject.projectNumber"
                          ></option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Тип вынесения</label>
                        <select
                          class="form-control"
                          v-model="transferProject.type_making"
                          id="type_making_add"
                        >
                          <option value="" disabled
                            >Укажите тип вынесения проекта
                          </option>
                          <option
                            v-for="item in directory.type_making"
                            v-bind:key="item.ID"
                            v-bind:value="item.ID"
                            v-text="item.NAME"
                          ></option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>№ п/п</label>
                        <select
                          class="form-control form-control_dis"
                          v-model="transferProject.uf_sort"
                          id="sort_add"
                        >
                          <option value="" disabled selected
                            >Укажите номер вопроса
                          </option>
                          <option
                            v-for="item in 100"
                            v-bind:key="item"
                            v-bind:value="item"
                            :disabled="checkIsVisibleDisableTranspher(item)"
                            v-text="item"
                            class="form-control"
                          ></option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Комментарий</label>
                        <textarea
                          class="form-control"
                          v-model="transferProject.comment"
                          placeholder="Укажите комментарий к вопросу"
                          style="resize: vertical;"
                        ></textarea>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="
                      showChangeSovet = false;
                      isViewTransferFormProject = false;
                      transferProject.id_sovet = null;
                    "
                  >
                    Отмена
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    data-dismiss="modal"
                  >
                    Создать
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- Диалог смены ЭС для проекта end -->

        <!-- Добавление задачи к вопросу -->
        <div
          v-if="isAddTaskDocModalView"
          class="modal fade in"
          :class="{ show: isAddTaskDocModalView }"
          tabindex="-1"
          role="dialog"
        >
          <form>
            <div class="modal-dialog modal-new-style" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    @click="setModalAddTaskDoc(false)"
                    type="button"
                    class="close"
                    aria-label="Close"
                  >
                    <span>&times;</span>
                  </button>
                  <h4 class="modal-title">Задачи</h4>
                </div>
                <div class="modal-body" style="margin-bottom: 20px;">
                  <div class="form-group" v-if="questions.typeSovet !== 'rgm'">
                    <label>Вид</label>
                    <select v-model="addTaskForm.VID" class="form-control">
                      <option
                        v-for="item in questions.ListVidB24"
                        :value="item.ID"
                        :key="item.ID"
                        v-text="item.NAME"
                      />
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Ответственный</label>
                    <select
                      v-model="addTaskForm.EXECUTOR_USER_ID"
                      class="form-control"
                      :disabled="questions.typeSovet !== 'rgm' ? true : false"
                    >
                      <option
                        v-for="item in questions.ListUserB24"
                        :value="item.ID"
                        :key="item.ID"
                        v-text="item.FULL_NAME"
                      />
                    </select>
                  </div>

                  <div class="form-group" v-if="questions.typeSovet === 'rgm'">
                    <label>Постановщик</label>
                    <select
                      v-model="addTaskForm.CREATOR_USER_ID"
                      class="form-control"
                    >
                      <option
                        v-for="item in questions.ListUserB24"
                        :value="item.ID"
                        :key="item.ID"
                        v-text="item.FULL_NAME"
                      />
                    </select>
                  </div>

                  <div class="form-group" v-if="questions.typeSovet === 'rgm'">
                    <label>Проект</label>
                    <Multiselect
                      label="LABEL"
                      class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                      style="min-height: 40px; height: auto; background-image: none;"
                      :limit="40"
                      :limitText="filterItemText"
                      track-by="ID"
                      v-model="addTaskForm.PROJECTS_LIST"
                      :options="questions.PROJECTS_KZ"
                      :multiple="true"
                      placeholder="Укажите проект(ы)"
                    >
                      <span slot="noOptions">Проекты не найдены</span>
                      <span slot="noResult">Проекты не найдены</span>
                    </Multiselect>
                  </div>

                  <div class="form-group" v-if="questions.typeSovet !== 'rgm'">
                    <label>Приоритет</label>
                    <select
                      v-model="addTaskForm.PRIORITY_ID"
                      class="form-control"
                    >
                      <option
                        v-for="item in questions.listPriorityTaskB24"
                        :value="item.ID"
                        :key="item.ID"
                        v-text="item.NAME"
                      />
                    </select>
                  </div>

                  <div class="form-group" v-if="questions.typeSovet === 'rgm'">
                    <label>Срок исполнения</label>
                    <datepicker
                      v-model="addTaskForm.DEADLINE"
                      :language="ru"
                      :monday-first="true"
                      input-class="form-control filter-input-datapicer form-control-data-inp"
                    />
                  </div>

                  <div class="form-group">
                    <table>
                      <tr>
                        <td style="padding-bottom: 10px;">
                          <label
                            for="UF_COMMENT"
                            class="expert-edit-form__label"
                            >Суть задачи</label
                          >
                        </td>
                        <td
                          style="padding-bottom: 10px;"
                          v-if="questions.typeSovet === 'es'"
                        >
                          <div class="switch-container">
                            <span
                              class="switch-text  switch-text-no"
                              :class="{
                                checked: !addTaskForm.UF_IS_TO_BE_LATER
                              }"
                            >
                            </span>
                            <label class="switch-box">
                              <input
                                type="checkbox"
                                :checked="addTaskForm.UF_IS_TO_BE_LATER"
                                @change="setIsToLater()"
                              />
                              <span
                                class="switch-box__slider switch-box__round"
                              />
                            </label>
                            <span
                              :class="{
                                checked: addTaskForm.UF_IS_TO_BE_LATER
                              }"
                              class="switch-text"
                              style="color: #555555"
                            >
                              будет уточнена позже
                            </span>
                          </div>
                        </td>
                      </tr>
                    </table>

                    <textarea
                      id="UF_COMMENT"
                      class="form-control  stl-textarea-rn"
                      :placeholder="
                        questions.typeSovet === 'rgm'
                          ? 'Напишите задачу'
                          : 'Напишите замечание'
                      "
                      style="min-height: 200px;"
                      v-model="addTaskForm.TASK"
                      :disabled="isDisabledTastTextarea ? true : false"
                    />
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    @click="setModalAddTaskDoc(false)"
                    type="button"
                    class="butt-stl butt-black"
                    data-dismiss="modal"
                  >
                    отменить
                  </button>
                  <button
                    @click="addTask"
                    type="button"
                    class="butt-stl butt-blue"
                  >
                    Добавить
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </form>
        </div>
        <!-- /.modal -->
        <!-- Добавление задачи к вопросу -->
      </div>

      <!-- История загрузки документов -->
      <div
        class="modal fade in"
        :class="{ show: isViewHistoryModal }"
        id="info-vote-modal"
        tabindex="-1"
        role="dialog"
      >
        <form>
          <div
            class="modal-dialog modal-new-style modal-close-active"
            role="document"
          >
            <div
              class="modal-content"
              v-if="historyDocTemp"
              style="min-width: 800px;"
            >
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  data-dismiss="modal"
                  @click="closeHistoryModal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">
                  История загрузки документа "{{ historyTitleName }}"
                </h4>
              </div>
              <div class="modal-body" style="margin-bottom: 0px;">
                <div class="form-group">
                  <table class="container-stl-table expert-table-stl">
                    <thead>
                      <th style="width: 57px;">№</th>
                      <th>Документ</th>
                      <th class="text-center stl-w-200">Дата загрузки</th>
                      <th>Сотрудник</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in historyDocTemp"
                        :key="index"
                        :class="!item.IS_ACTUAL ? 'td-color-gray' : ''"
                      >
                        <td>{{ index + 1 }}</td>
                        <td
                          style="max-width: 500px; word-wrap: break-word; word-break: break-all;"
                        >
                          <a
                            v-if="
                              item.FILE_FULL_INFO && item.FILE_FULL_INFO !== ''
                            "
                            :href="item.FILE_FULL_INFO"
                            target="_blank"
                            class="stl-link-black"
                          >
                            {{ item.UF_FILE_NAME }}
                          </a>
                        </td>
                        <td class="text-center">{{ item.UF_DATE_LOAD }}</td>
                        <td class="text-center">
                          {{ item.USER_FIO_DOWNLOAD }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
      <!-- История загрузки документов -->
    </div>
    <!-- wraper -->
    <!-- FOTER -->
    <div class="footer footer-fix" style="z-index: 5;">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp"></div>
        </div>
      </div>
    </div>
    <!-- FOTER -->
  </div>
</template>

<script>
import {
  FETCH_QUESTIONS_LIST,
  SET_MAIN_MENU,
  SET_IS_VIEW_ALL_EXPERTISE,
  FETCH_DIRECTORIES
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import { ExpertAdvice, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import TableHead from "../project/documents/TableHead.vue";

export default {
  name: "Questions",
  components: { TableHead, Multiselect, Datepicker },
  title: "Вопросы",
  data() {
    return {
      isEditMode: false,
      isDelModalView: false,
      isDelDocModalView: false,
      isAddDocModalView: false,
      isEditDocModalView: false,
      accept: "",
      addDocForm: {
        UF_SORT: "",
        UF_TYPE_DOCUMENTS: "",
        UF_NAME: "",
        FILE: ""
      },
      addTaskForm: {
        VID: 0,
        CREATOR_USER_ID: 0,
        EXECUTOR_USER_ID: 0,
        PRIORITY_ID: 0,
        DEADLINE: "",
        TASK: "",
        ACTIVE_USER: 0,
        UF_IS_TO_BE_LATER: 0
      },
      isDisabledTastTextarea: 0,
      editDocForm: {
        ID: "",
        UF_SORT: "",
        UF_TYPE_DOCUMENTS: "",
        UF_NAME: "",
        FILE: ""
      },
      fileName: "",
      docId: "",
      doc: "",
      isAddTaskDocModalView: false,
      ru: ru,
      isCloseDocumentRazdel: true,
      isViewHistoryModal: false,
      historyDocTemp: {
        ID: 0,
        UF_NAME: "",
        UF_FILE_ID: 0,
        FILE_FULL_INFO: "",
        UF_FILE_NAME: "",
        UF_EXT: "",
        UF_DATE_LOAD: "",
        IS_ACTUAL: 0
      },
      transferProject: {
        id_question: 0,
        id_sovet: 0,
        type_question: "",
        uf_sort: "",
        type_making: "",
        comment: "",
        projectId: 0,
        projectNumber: ""
      },
      historyTitleName: "",
      isLoaded: false,
      tempProject: [],
      showChangeSovet: false,
      isViewTransferFormProject: false,
      showDialogEndWorkProject: false
    };
  },
  computed: {
    ...mapGetters([
      "questions",
      "isQuestionsLoading",
      "directory",
      "currentUser"
    ]),
    isNeedNaming() {
      let el = this.questions.SP_TYPE_DOCUMENTS.find(
        el => el.ID === this.addDocForm.UF_TYPE_DOCUMENTS
      );
      return el && el.IS_USER_TYPE === 1;
    },
    isNeedNamingEdit() {
      let el = this.questions.SP_TYPE_DOCUMENTS.find(
        el => el.ID === this.editDocForm.UF_TYPE_DOCUMENTS
      );
      return el && el.IS_USER_TYPE === 1;
    }
  },

  async mounted() {
    await this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }*/
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          /*avMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });*/
        } else {
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }*/
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          /*navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });*/
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
      });
    } else {
      await this.$store.dispatch(SET_MAIN_MENU, [
        {
          name:
            this.currentUser.TYPE_USER === "manager"
              ? "Реестр проектов"
              : "Мои проекты",
          route: "Projects"
        }
      ]);
    }

    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "status",
      "type_making",
      "sp_question_expert_sovet_type"
    ]);

    this.fetchItems();
  },

  methods: {
    setEditMode(flag) {
      this.isEditMode = flag;
    },
    setModalAddDoc(flag) {
      this.isAddDocModalView = flag;
      if (!flag) {
        this.addDocForm.UF_SORT = this.questions.item.DOCUMENTS_COUNT + 1;
        this.addDocForm.FILE = "";
        this.addDocForm.FILE_NAME = "";
        this.addDocForm.UF_NAME = "";
        this.addDocForm.UF_TYPE_DOCUMENTS = "";
        this.fileName = "";
      }
    },
    setModalEditDoc(flag, row = {}) {
      this.isEditDocModalView = flag;
      if (!flag) {
        this.editDocForm.ID = "";
        this.editDocForm.UF_SORT = "";
        this.editDocForm.FILE = "";
        this.editDocForm.FILE_NAME = "";
        this.editDocForm.UF_NAME = "";
        this.editDocForm.UF_TYPE_DOCUMENTS = "";
        this.fileName = "";
      } else {
        this.editDocForm.ID = row.ID;
        this.editDocForm.UF_SORT = row.UF_SORT;
        this.editDocForm.UF_NAME = row.UF_USER_FILE_NAME; //row.UF_NAME;
        this.editDocForm.UF_TYPE_DOCUMENTS = row.TYPE.UF_TYPE_DOCUMENTS;
        this.fileName = row.UF_NAME;
      }
    },
    setModalDelAdvice(flag) {
      this.isDelModalView = flag;
    },
    setModalDelDoc(flag, item = "") {
      this.isDelDocModalView = flag;
      if (flag) {
        this.doc = item;
        this.docId = item.ID;
      } else {
        this.doc = "";
        this.docId = "";
      }
    },
    resetChanges() {
      this.setEditMode(false);
      this.fetchItems();
    },
    saveQuestion() {
      ExpertAdvice.editProjectAdvice(
        this.$route.params.id,
        this.$route.params.projectId,
        this.questions.item
      )
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.setEditMode(false);
          }
        })
        .catch(err => {
          console.log(err);
        });
      return false;
    },
    removeAdvice() {
      ExpertAdvice.deleteProjectAdvice(this.$route.params.projectId).then(
        ({ data }) => {
          if (data.errorArr && data.errorArr.length) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.moveBack();
          }
        },
        this
      );
    },
    removeDoc() {
      ExpertAdvice.deleteProjectAdviceDocument(this.docId).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.setModalDelDoc(false);
          this.fetchItems();
        }
      }, this);
    },
    moveBack() {
      this.$router.push({
        name: "EAList",
        params: { id: this.$route.params.id }
      });
    },
    openDoc(id) {
      ExpertAdvice.getLinkByFileAdvise(id).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    openGeneretaDoc(id) {
      ExpertAdvice.getLinkByFileGenerateAdvise(id).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    changeFile(e) {
      let files = e.target.files;

      if (files.length > 0) {
        let file = files[0];

        if (file.size < 1024 * 1024 * 100) {
          this.fileName = file.name;
          this.addDocForm.FILE = file;
          this.addDocForm.FILE_NAME = this.fileName;
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      }
    },

    editFile(e) {
      let files = e.target.files;

      if (files.length > 0) {
        let file = files[0];

        if (file.size < 1024 * 1024 * 100) {
          this.fileName = file.name;
          this.editDocForm.FILE = file;
          this.editDocForm.FILE_NAME = this.fileName;
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      }
    },
    addDoc() {
      let formData = new FormData();

      formData.append("UF_SORT", this.addDocForm.UF_SORT);
      formData.append("UF_TYPE_DOCUMENTS", this.addDocForm.UF_TYPE_DOCUMENTS);
      formData.append("UF_NAME", this.addDocForm.UF_NAME);

      if (this.addDocForm.FILE) {
        formData.append("FILE", this.addDocForm.FILE);
      }

      ExpertAdvice.addProjectAdviceDocument(
        this.$route.params.projectId,
        formData
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.setModalAddDoc(false);
          this.fetchItems();
        }
      }, this);
    },

    editDoc() {
      let formData = new FormData();

      formData.append("ID", this.editDocForm.ID);
      formData.append("UF_SORT", this.editDocForm.UF_SORT);
      formData.append("UF_TYPE_DOCUMENTS", this.editDocForm.UF_TYPE_DOCUMENTS);
      formData.append("UF_NAME", this.editDocForm.UF_NAME);

      if (this.editDocForm.FILE) {
        formData.append("FILE", this.editDocForm.FILE);
      }

      ExpertAdvice.editProjectAdviceDocument(
        this.$route.params.projectId,
        this.editDocForm.ID,
        formData
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.setModalEditDoc(false);
          this.fetchItems();
        }
      }, this);
    },
    fetchItems() {
      this.$store
        .dispatch(FETCH_QUESTIONS_LIST, {
          id: this.$route.params.id,
          idRow: this.$route.params.projectId
        })
        .then(() => {
          document.title = unescape(this.questions.TITLE);
          this.addDocForm.UF_SORT = this.questions.item.DOCUMENTS_COUNT + 1;
          if (this.questions) {
            this.isLoaded = true;
          }
        }, this);
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    setModalAddTaskDoc(flag) {
      this.isAddTaskDocModalView = flag;
      this.addTaskForm.VID = 0;
      this.addTaskForm.CREATOR_USER_ID = 0;
      this.addTaskForm.EXECUTOR_USER_ID = 0;

      if (this.questions.typeQuestion == "project") {
        this.addTaskForm.EXECUTOR_USER_ID =
          this.questions.item.MANAGER_B24.UF_MANAGER_ID > 0
            ? this.questions.item.MANAGER_B24.UF_MANAGER_ID
            : this.questions.activeUserIdByB24;
      } else {
        this.addTaskForm.EXECUTOR_USER_ID =
          this.questions.item.SPEAKER_B24.ID > 0
            ? this.questions.item.SPEAKER_B24.ID
            : this.questions.activeUserIdByB24;
      }

      if (this.questions.typeSovet === "rgm") {
        this.addTaskForm.CREATOR_USER_ID = this.questions.activeUserIdRGMByB24;
      } else {
        this.addTaskForm.CREATOR_USER_ID = this.questions.activeUserIdByB24;
      }

      this.addTaskForm.PRIORITY_ID = 0;
      if (this.questions.typeSovet === "es") {
        this.addTaskForm.PRIORITY_ID = 5684;
      }

      this.addTaskForm.TASK = "";
      this.addTaskForm.UF_IS_TO_BE_LATER = false;
      this.isDisabledTastTextarea = 0;
      this.addTaskForm.DEADLINE = "";
      this.addTaskForm.ACTIVE_USER = this.questions.activeUserIdByB24;

      console.log(this.addTaskForm);
    },
    setIsToLater() {
      this.addTaskForm.UF_IS_TO_BE_LATER = !this.addTaskForm.UF_IS_TO_BE_LATER;

      if (this.addTaskForm.UF_IS_TO_BE_LATER) {
        this.isDisabledTastTextarea = 1;
        this.addTaskForm.TASK = "будет уточнена позже";
      } else {
        this.isDisabledTastTextarea = 0;
      }
    },
    addTask() {
      console.log(this.addTaskForm);
      ExpertAdvice.addProjectAdviceTask(this.$route.params.projectId, {
        ...this.addTaskForm
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        } else {
          this.setModalAddTaskDoc(false);
          this.fetchItems();
        }
      }, this);
    },
    getArchive(id) {
      ExpertAdvice.getLinkFileArchive(id).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      }, this);
    },
    getArchiveAll() {
      ExpertAdvice.getLinkFileArchiveAll(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        },
        this
      );
    },
    checkIsVisibleDisable(id) {
      let t = this.questions.allSortList.filter(c => c === id);
      return t.length === 0 ? false : true;
    },
    closeRazdel() {
      this.isCloseDocumentRazdel = !this.isCloseDocumentRazdel;
    },
    closeHistoryModal() {
      this.isViewHistoryModal = false;
      this.historyTitleName = "";
    },
    openHistoryModal(element) {
      this.isViewHistoryModal = true;
      this.historyDocTemp = element.HISTORY_DOC_LIST;
      this.historyTitleName =
        element.UF_USER_FILE_NAME != ""
          ? element.UF_USER_FILE_NAME
          : element.UF_NAME;
    },
    isDeleteProjectQuestion(tempProject) {
      if (
        (this.questions.typeSovet === "es" ||
          this.questions.typeSovet === "ns") &&
        tempProject.TYPE_MAKING
      ) {
        if (
          tempProject.TYPE_MAKING.CODE &&
          (tempProject.TYPE_MAKING.CODE === "first" ||
            tempProject.TYPE_MAKING.CODE === "re-issuance") &&
          tempProject.UF_PROJECT_ID > 0
        ) {
          return true;
        }
      }
      return false;
    },
    setDataTransferProject(tempProject) {
      this.transferProject.id_question = tempProject.ID;
      this.transferProject.id_sovet = null;
      this.transferProject.type_question = tempProject.UF_TYPE_QUESTION;
      this.transferProject.projectId = tempProject.UF_PROJECT_ID;
      this.transferProject.projectNumber =
        "№" + tempProject.PROJECT_UF_NUMBER + " " + tempProject.PROJECT_UF_NAME;
      this.transferProject.comment = "";
      this.transferProject.type_making = null;
      this.transferProject.uf_sort = null;
      this.isDelModalView = false;
      this.showChangeSovet = true;
    },
    changeTransferProject() {
      if (this.transferProject.id_sovet > 0) {
        this.isViewTransferFormProject = true;
        this.transferProject.uf_sort = null;
      }
    },
    checkIsVisibleDisableTranspher(i) {
      let t = this.questions.LIST_SOVET_ACTUAL.filter(
        c => c.ID === this.transferProject.id_sovet
      );
      return t[0].COUNT_QUESTION >= i ? true : false;
    },
    onSendTransferProject() {
      ExpertAdvice.onSendTransferProject(
        this.transferProject.id_sovet,
        this.transferProject.id_question,
        {
          UF_TYPE_MAKING: this.transferProject.type_making,
          UF_COMMENT: this.transferProject.comment,
          UF_SORT: this.transferProject.uf_sort,
          UF_PROJECT_ID: this.transferProject.projectId
        }
      )
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.moveBack();
            this.showEditNewProject = false;
            this.showChangeSovet = false;
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    setEndWorkProject() {
      console.log(this.questions.item);
      ExpertAdvice.onSetEndWorkProject(this.questions.item.ID)
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.moveBack();
            this.showEditNewProject = false;
            this.showChangeSovet = false;
            this.showDialogEndWorkProject = false;
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    }
  }
};
</script>
